import React, { Component } from 'react';
import { ButtonToolbar, Button } from 'react-bootstrap/lib'
import { LinkContainer } from 'react-router-bootstrap'
import Api from './Api'
class Topmenu extends Component {
  constructor() {
    super();

    this.handleClick = this.handleClick.bind(this);
  }
  handleClick(event) {
    Api.clearSession();
    this.props.fnc(<LinkContainer exact to="/account"><Button className="top-menu-btn" bsStyle="default">Registreren / Inloggen</Button></LinkContainer>);
  }

  componentDidMount() {
    if (Api.isLoggedIn()) {
      if (Api.isAdmin()) {
        this.props.fnc(
          <ButtonToolbar>
            <LinkContainer exact to="/cursusinformatie"><Button className="top-menu-btn" bsStyle="default">Cursus informatie</Button></LinkContainer>
            <LinkContainer exact to="/evenementenkalender"><Button className="top-menu-btn" bsStyle="default">Evenementenkalender</Button></LinkContainer>
            <LinkContainer exact to="/admin"><Button className="top-menu-btn webmanagerBtn" bsStyle="default">Webmanager</Button></LinkContainer>
            <LinkContainer exact to="/admin"><Button className="top-menu-btn" bsStyle="default">Hallo {Api.getUsername()}</Button></LinkContainer>
            <LinkContainer exact to="/account" onClick={() => this.handleClick()}><Button className="top-menu-btn" bsStyle="default">Uitloggen</Button></LinkContainer>
          </ButtonToolbar>
        );
      } else {
        this.props.fnc(
          <ButtonToolbar>
            <LinkContainer exact to="/cursusinformatie"><Button className="top-menu-btn" bsStyle="default">Cursus informatie</Button></LinkContainer>
            <LinkContainer exact to="/evenementenkalender"><Button className="top-menu-btn" bsStyle="default">Evenementenkalender</Button></LinkContainer>
            <LinkContainer exact to="/account/mijn-cr"><Button className="top-menu-btn" bsStyle="default">Hallo {Api.getUsername()}</Button></LinkContainer>
            <LinkContainer exact to="/account" onClick={() => this.handleClick()}><Button className="top-menu-btn" bsStyle="default">Uitloggen</Button></LinkContainer>
          </ButtonToolbar>
        );
      }

    } else {
      this.props.fnc(
        <ButtonToolbar>
          <LinkContainer exact to="/cursusinformatie"><Button className="top-menu-btn" bsStyle="default">Cursus informatie</Button></LinkContainer>
          <LinkContainer exact to="/evenementenkalender"><Button className="top-menu-btn" bsStyle="default">Evenementenkalender</Button></LinkContainer>
          <LinkContainer exact to="/account"><Button className="top-menu-btn" bsStyle="default">Registreren / Inloggen</Button></LinkContainer>
        </ButtonToolbar>
      );
    }
  }



  render() {
    return (
      <div>
        {this.props.button}
      </div>
    );
  }
}

export default Topmenu;


// WEBPACK FOOTER //
// ./src/components/Global/Modules/Topmenu.js